import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Contabilidad, ContabilidadResponse } from '@p-p-portafolio/promociones/interfaces/contabilidad';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';
import { SwalService } from '@shared/utils/swal.service';
import { ContabilidadFormComponent } from '@p-p-portafolio/promociones/contabilidad-promocion/contabilidad-form/contabilidad-form.component';
import { ProductosService } from '@pages/tipos-credito/services/productos.service';
import { Producto } from '@p-parametria/mantenimiento/abc-empresas/interfaces/producto';
import { ProductosFormComponent } from './productos-form/productos-form.component';
import { ProductoRangosService } from '@pages/tipos-credito/services/producto-rangos.service';
import { ProductoRangos } from '@p-parametria/mantenimiento/abc-empresas/interfaces/productoRangos';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.css']
})

export class ProductosComponent implements OnInit {
  displayedColumns: string[] = [ 'actions', 'consecutivo', 'paquete', 'producto', 'porcentaje', 'tasaMin',  'plazoMin'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  perfil = '';
  private readonly _width: string = '1000px';
  constructor(
    private _productoService: ProductoRangosService,
    private route: ActivatedRoute,
    public _dialog: MatDialog,
    private _swalService: SwalService
  ) { }

  ngOnInit(): void {
    this.perfil = JSON.parse(sessionStorage.getItem('clavePerfil'));
    this.dataSource.paginator = this.paginator;
    this.getDataSource();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getDataSource() {
    this._productoService.read(this.perfil).subscribe((res) => {
      this.dataSource.data = res.data;     
    });
  }

  add(){
    const dialogRef = this._dialog.open(ProductosFormComponent, {
      width: this._width
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.getDataSource();
    });
  }

  delete(model: ProductoRangos) {
    const dialogRef = this._dialog.open(ConfirmDeletionComponent, {
      width: '310px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._productoService.delete(model).subscribe((res) => {
          if (res) this._swalService.success('Eliminado');
          else this._swalService.error('No Eliminado');
          this.getDataSource();
        });
      }
    });
  }

  edit(model: ProductoRangos){
    const dialogRef = this._dialog.open(ProductosFormComponent, {
      width: this._width,
      data: model
    });
    dialogRef.afterClosed().subscribe((result) => {
     this.getDataSource();
    });
  }
}

